import React from 'react';
import Header from './Header.js';
import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import Box from '@material-ui/core/Box';

import { CardMedia } from '@material-ui/core';

//import screenshots from './Screenshots_Store.png';
import video_mdm from './Video_MDM.gif';
import video_time from './Video_Time-Based.gif';
import video_info from './Video_Info.gif'
import app_store from './App_Store_Download.svg';

import Disclaimer from './Disclaimers.js';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        padding: 20,
        paddingTop: 100,
        margin: 'auto',
        maxWidth: 800,
    },
  card: {
    //padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
      //margin: theme.spacing(2),
      alignItems: 'center',
  }, 
  cardTextRight: {
    color: theme.palette.text.secondary,
    textAlign: 'right',
    alignItems: 'right',
  },
  cardTextLeft: {
    color: theme.palette.text.secondary,
    textAlign: 'left',
    alignItems: 'left',
  },
  media: {
    //width: 100,
    borderRadius: 20,
    borderStyle: 'solid',
    borderWidth: 10,
    borderColor: 'black',

    },
    appStoreImage: {
        width: 150,
        opacity: 0.5, //once available, remove opacity
        //padding: 10,
    },
    availableSoonText: {
        padding: 10,
        color: theme.palette.text.secondary,
    }
}));

export default function MedBillingScreen (props) {
    const classes = useStyles();
    return <>
            <div className={classes.root}>
                <Header title="The Medical Billing Calculator for iPhone or iPad" subTitle="An E/M Established Outpatient CPT™ Coding Aid for Medical Providers, by Psych-Apps"/>
                <br/>
                <Grid container spacing={3}>
                    <Grid item xs={12} container justify="flex-end">
                     <CardMedia className={classes.appStoreImage} image={app_store} component="img" alt="app store button"/> <Typography variant="h6" color="inherit" className={classes.availableSoonText}>Coming Soon!</Typography>
                    </Grid>
                    <Grid item xs={6}>
                            <Box>
                                <CardMedia className={classes.media} image={video_mdm} component="img" alt="mdm video" />
                            </Box>
                        </Grid>
                        <Grid item xs={6} container justify='flex-end'>
                            <Box>
                                <br/>
                                <br/>
                                <Typography variant="body1" className={classes.cardTextRight}>The Med-Billing Calculator is an <em>iPhone®</em> and <em>iPad®</em> app developed by <em>Psych-Apps</em> to help providers estimate <strong>E/M established outpatient</strong> CPT™ medical codes (99212 through 99215 series) based on the new 2021 American Medical Association (AMA) guidelines.</Typography>
                                <br/><br/>

                                <Typography variant="body1" className={classes.cardTextRight}>Easily use Medical-Decision-Based (MDM) framework (i.e. using complexity of visit rather than time for level of coding)...</Typography>
                            </Box>
                        </Grid> 

                        <Grid item xs={6}>
                            <Box>
                                <br/>
                                <br/>
                                <Typography variant="body1" className={classes.cardTextLeft}>Or use classic time-based framework for longer appointment types...</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box>
                                <CardMedia className={classes.media} image={video_time} component="img" alt="time video" />
                            </Box>
                        </Grid>

                        <Grid item xs={6}>
                            <Box>
                                <CardMedia className={classes.media} image={video_info} component="img" alt="info video" />
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box>
                                <br/>
                                <br/>
                                <Typography variant="body1" className={classes.cardTextRight}>Includes details to help understand the terminology from the 2021 AMA guidelines...</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Box>
                                <br/>
                                <br/>
                                <Typography variant="subtitle2" className={classes.cardTextLeft}>iPhone and iPad are registered trademarks of Apple Inc. CPT is a registered trademark of the American Medical Association.</Typography>
                            </Box>
                        </Grid>
                </Grid>
                <Disclaimer/>
            </div>
        </>
}

/*  <Grid item xs={12}>
                        <Box>
                         <CardMedia className={classes.media} image={screenshots} component="img" alt="screenshot" />
                        </Box>
                        <br />
                    </Grid> */